<template>
    <v-row>
        <v-col cols="6">
            <validation-provider v-slot="{ errors }" name="Name" rules="required">
                <v-text-field v-model="localItem.name" :error-messages="errors"
                              :label="$vuetify.lang.t('$vuetify.pages.categories.gradeName')" autofocus
                              @input="change"/>
            </validation-provider>
        </v-col>
        <v-col cols="6">
            <validation-provider v-slot="{ errors }" name="Value" rules="required|numeric">
                <v-text-field v-model="localItem.value" :error-messages="errors"
                              :label="$vuetify.lang.t('$vuetify.pages.categories.gradeValue')"
                              :min="0" type="number" @input="change"/>
            </validation-provider>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "KurccGradeItem",
    props: {
        grade: {
            required: true
        }
    },
    data() {
        return {
            localItem: null
        }
    },
    watch: {
        grade: {
            handler: 'setLocalItem',
            deep: true,
            immediate: true
        }
    },
    methods: {
        change() {
            this.$emit('change', this.localItem)
        },
        setLocalItem() {
            this.localItem = this.$lodash.cloneDeep(this.grade)
        }
    }
}
</script>
